import 'swiper/swiper-bundle.css';

import React from 'react';
import { Autoplay, Navigation, Pagination, Mousewheel } from 'swiper/modules';
import { Swiper as ReactSwiper } from 'swiper/react';

const Swiper = React.forwardRef(({ children, ...props }, ref) => (
  <ReactSwiper
    ref={ref}
    modules={[Autoplay, Mousewheel, Navigation, Pagination]}
    mousewheel={{ forceToAxis: true }}
    {...props}
  >
    {children}
  </ReactSwiper>
));

Swiper.displayName = 'Swiper';

export { Swiper };
